import { createReducer } from 'typesafe-actions';
import {
  PRODUCTS_COMPARE_MANAGE,
  PRODUCTS_COMPARE_LOAD_DATA,
  SEND_PRODUCTS_COMPARE_ACTION,
  MANAGE_PRODUCT_IN_COMPARE_LIST,
  AllProductsCompareActions,
} from '../actions';
import { LoadingState } from '../types';

export const userActionLoading = createReducer<boolean, AllProductsCompareActions>(false)
  .handleAction(MANAGE_PRODUCT_IN_COMPARE_LIST, () => true)
  .handleAction(SEND_PRODUCTS_COMPARE_ACTION, () => true)
  .handleAction(
    [PRODUCTS_COMPARE_MANAGE.success, PRODUCTS_COMPARE_MANAGE.failure, PRODUCTS_COMPARE_MANAGE.cancel],
    () => false,
  );

export const loading = createReducer<
  { manage: LoadingState; loadData: LoadingState },
  AllProductsCompareActions
>({
  manage: 'none',
  loadData: 'none',
})
  .handleAction(PRODUCTS_COMPARE_MANAGE.request, (state) => ({ ...state, manage: 'loading' }))
  .handleAction(
    [PRODUCTS_COMPARE_MANAGE.success, PRODUCTS_COMPARE_MANAGE.failure, PRODUCTS_COMPARE_MANAGE.cancel],
    (state) => ({ ...state, manage: 'loaded' }),
  )
  .handleAction(PRODUCTS_COMPARE_LOAD_DATA.request, (state) => ({ ...state, loadData: 'loading' }))
  .handleAction(
    [
      PRODUCTS_COMPARE_LOAD_DATA.success,
      PRODUCTS_COMPARE_LOAD_DATA.failure,
      PRODUCTS_COMPARE_LOAD_DATA.cancel,
    ],
    (state) => ({ ...state, loadData: 'loaded' }),
  );
